import { render, staticRenderFns } from "./SOPPicker.vue?vue&type=template&id=684d8370&scoped=true&"
import script from "./SOPPicker.vue?vue&type=script&lang=js&"
export * from "./SOPPicker.vue?vue&type=script&lang=js&"
import style0 from "./SOPPicker.vue?vue&type=style&index=0&id=684d8370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d8370",
  null
  
)

export default component.exports